import { URL_POST_SERVICIO } from "../../constants/url";
import { POST } from "../../utils/fetch";
import { startLoadServicio } from "./serviciosActions";

export const startPostServicio = (actualizacionServicio) => {
  return async (dispatch) => {
    console.log({ actualizacionServicio });

    const resul = await POST(URL_POST_SERVICIO, actualizacionServicio);

    if (resul !== -1) {
      dispatch(startLoadServicio(actualizacionServicio.folioAsignacion));
    }
  };
};
